import React from 'react';
import { css } from '@emotion/core';
import { theme } from '@weave/theme-original';
import { Heading, NakedButton, Text, CaretRightIcon } from '@weave/design-system';
import { OrgHierarchy } from '@weave/schema-gen-ts/dist/apis/api/identity/v1/api.pb';

const divisionCard = css`
  border: 1px solid ${theme.colors.gray300};
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing(2, 2.5)};
  margin-bottom: ${theme.spacing(2)};

  &:last-child {
    margin-bottom: 0;
  }
`;

const divisionHeading = css`
  margin: ${theme.spacing(0, 0, 1)};
`;

const locationList = css`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const locationButton = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing(2)};
  width: 100%;
  min-height: 36px;
  padding: ${theme.spacing(0.75, 1)};
  border-radius: ${theme.borderRadius.small};
  text-align: left;
  :hover {
    background-color: ${theme.colors.gray200};
  }
`;

const locationDetails = css`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: ${theme.spacing(0.5)};
  min-width: 0;
`;

const locationSlug = css`
  overflow-wrap: anywhere;
`;

const locationCaret = css`
  flex: 0 0 auto;
`;

const emptyDivision = css`
  margin: 0;
`;

type DivisionHierarchy = NonNullable<OrgHierarchy['divisions']>[number];

type Props = {
  divisions: DivisionHierarchy[];
  onSelectLocation: (locationId?: string) => void;
};

export const OrgHierarchyTab = ({ divisions, onSelectLocation }: Props) => {
  if (divisions.length === 0) {
    return <Text color="light">This organization has no divisions or locations.</Text>;
  }

  return (
    <>
      {divisions.map((divisionHierarchy) => (
        <div key={divisionHierarchy.division?.divisionId} css={divisionCard}>
          <Heading level={3} css={divisionHeading}>
            {divisionHierarchy.division?.name}
          </Heading>
          {(divisionHierarchy.locations ?? []).length === 0 ? (
            <Text css={emptyDivision} color="light">
              No locations in this division.
            </Text>
          ) : (
            <ul css={locationList}>
              {divisionHierarchy.locations!.map((location) => (
                <li key={location.locationId}>
                  <NakedButton
                    css={locationButton}
                    onClick={() => onSelectLocation(location.locationId)}
                  >
                    <span css={locationDetails}>
                      <span>{location.name}</span>
                      <Text as="span" css={locationSlug} color="light">
                        ({location.slug})
                      </Text>
                    </span>
                    <CaretRightIcon css={locationCaret} color="light" />
                  </NakedButton>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </>
  );
};
